import { render } from "./memberSearch.vue?vue&type=template&id=572d2c9a"
import script from "./memberSearch.vue?vue&type=script&lang=js"
export * from "./memberSearch.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__